import { render } from "./Paiement.vue?vue&type=template&id=3288fdc8&scoped=true"
import script from "./Paiement.vue?vue&type=script&lang=js"
export * from "./Paiement.vue?vue&type=script&lang=js"

import "./Paiement.vue?vue&type=style&index=0&id=3288fdc8&scoped=true&lang=css"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3288fdc8"]])

export default __exports__